<template>
    <div class="detail-content school_business nqt__custom_course__online">

        <!-- Tiêu đề -->
        <div class="primarylists list-mobile">
            <div class="titles clear title_mobile">
                <img src="../../../static/images/icon-st.jpg"/>
                <div class="title l">
                    {{$t('home.liveMessage')}}
                </div>
            </div>
        </div>

        <!-- Khung tìm kiếm -->
        <div class="el_dialog_live_lesson lesson-new">

            <!-- Btn: Ẩn/Hiện khung tìm kiếm ở mobile -->
            <div class="btn-hiden-display-mobile" v-if="mobile">
                <button class="btn-hiden" @click="disableForm = true" v-if="!disableForm">
                    {{$t('live_lesson.hiden')}}
                </button>
                <button class="btn-display" @click="disableForm = false" v-if="disableForm">
                    {{$t('live_lesson.display')}}
                </button>
            </div>

            <!-- Form: Tìm kiếm -->
            <el-form :inline="true" :model="form" class="el-row-box" ref="form" v-if="!disableForm">

                <!-- Tên khóa học -->
                <el-row :gutter="24" class="mg-bt-20">
                    <el-col :span="24" class="grid-content bg-purple kb-353">
                        <el-input :placeholder="$t('courseOnline.courseNameInput')" v-model="form.courseName" clearable>
                            <template slot="prepend">
                                {{$t("courseOnline.courseName")}}
                            </template>
                        </el-input>
                    </el-col>
                </el-row>

                <!-- Trạng thái - Thời gian diễn ra -->
                <el-row>

                    <!-- Thời gian -->
                    <el-col :span="mobile ? 24 : 6">
                        <el-col :span="mobile ? 7 : 8" class="tt_nqt_tl not_mb status__mb">
                            <span>{{$t('home.status')}}</span>
                        </el-col>
                        <el-col :span="mobile ? 17 : 16">
                            <el-form-item>
                                <div class="select-new not_mb">
                                    <select v-model="form.status" class="my_select_live_lesson">
                                        <option v-for="item in optionStatus" :key="item.value" :value="item.value">
                                            {{ item.label }}
                                        </option>
                                    </select>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-col>

                    <!-- Thời gian hiển thị ở PC -->
                    <el-col :span="18" :class="{not_mbhhh: !mobile}" v-if="!mobile">
                        <el-col :span="7" class="tt_nqt_tl" :class="{not_mb_jsi: !mobile}">
                            <span>{{$t('courseOnline.timeCourse')}}</span>
                        </el-col>
                        <el-col :span="mobile ? 12 : 8" class="nqt__pl5">
                            <el-form-item>
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.from" type="date"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" :class="{nqt782k: !mobile}">
                            <span style="font-size: 25px;">&#8764;</span>
                        </el-col>
                        <el-col :span="mobile ? 12 : 8">
                            <el-form-item>
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.to" type="date"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-row>

                <!-- Thời gian hiển thị ở mobile -->
                <el-row v-if="mobile">
                    <el-col :span="24" class="tt_nqt_tl not_mb_jmb_5">
                        <span>{{$t('courseOnline.timeCourse')}}</span>
                    </el-col>
                    <el-col :span="24" class="mq_js">
                        <el-col :span="11">
                            <el-form-item>
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.from" type="date"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" class="not_osn nqt782k">
                            <span style="font-size: 25px;">&#8764;</span>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item>
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.to" type="date"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-row>

                <!-- Btn: Tìm kiếm - Reset - Download -->
                <el-col :span="24" :class="[{btn__mb: mobile}]" style="height: auto !important;">
                    <el-button class="exam_btn btn-login" :class="[{btn__pc: !mobile}]" style="float: right;" @click="reset()">
                        {{$t("new.title85")}}
                    </el-button>
                    <el-button class="exam_btn btn-login" :class="[{btn__pc: !mobile}]" style="float: right;" @click="search(form)">
                        {{$t("scoreStatistics.search")}}
                    </el-button>
                    <el-button v-if="userType != 2 && !mobile" @click="data.length ? downloadAll() : false" :class="[{ disable: !data.length }, {btn__pc: !mobile}, {btn__pc_left: !mobile}]" class="exam_btn btn-login">
                        {{$t('manage.download')}} &#10515;
                    </el-button>
                </el-col>
            </el-form>

            <!-- Danh sách khóa học online ở PC -->
            <div class="el_dialog_live_lesson live-lesson-pc nqt__pc_table__online">
                <div :class="{active_live_lesson: gridData.length == 0}">
                    <el-table :data="gridData" v-if="gridData.length" @row-click="joinLive" @header-click="sortTable" :header-cell-style="tableHeaderStyle">
                        <el-table-column property="courseName" :render-header="icons" :label="$t('home.courseName')" min-width="100" max-width="200" show-overflow-tooltip header-align="left" align="left">
                            <template slot-scope="scope">
                                <span :class="[{actt__tt__g: scope.row.status == 1}, {actt__tt__r: scope.row.status == 2}, {actt__tt__b: scope.row.status == 2}]">{{scope.row.courseName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="liveDate" :render-header="icons" class-name="date__mn" :label="$t('home.teachingTime')" min-width="80" header-align="center" show-overflow-tooltip align="center">
                            <template slot-scope="scope">
                                <span :class="[{actt__tt__g: scope.row.status == 1}, {actt__tt__r: scope.row.status == 2}, {actt__tt__b: scope.row.status == 2}]">{{scope.row.liveDate}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="liveTimeStart" :render-header="icons" class-name="date__lg" :label="$t('studySituationList.validityPeriodStart')" min-width="100" show-overflow-tooltip header-align="center" align="center">
                            <template slot-scope="scope">
                                <span :class="[{actt__tt__g: scope.row.status == 1}, {actt__tt__r: scope.row.status == 2}, {actt__tt__b: scope.row.status == 2}]">{{scope.row.liveTimeStart}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="liveTimeEnd" :render-header="icons" class-name="date__lg" :label="$t('studySituationList.validityPeriodEnd')" min-width="100" show-overflow-tooltip header-align="center" align="center">
                            <template slot-scope="scope">
                                <span :class="[{actt__tt__g: scope.row.status == 1}, {actt__tt__r: scope.row.status == 2}, {actt__tt__b: scope.row.status == 2}]">{{scope.row.liveTimeEnd}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('home.status')" min-width="60" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span type="text" size="small" v-if="scope.row.status == 1">
                                    <div style="color: #118e07;">
                                        <span class="icon-liveStatus">
                                            <img src="../../../static/images/icon_stop.png"/>
                                        </span>
                                        {{ $t("new.title7") }}
                                    </div>
                                </span>
                                <span type="text" size="small" v-if="scope.row.status == 2">
                                    <div>
                                        <span class="icon-liveStatus">
                                            <img src="../../../static/images/icon_online.png"/>
                                        </span>
                                        <span style="color: #da251d;">{{ $t("new.title8") }}</span>
                                    </div>
                                </span>
                                <span type="text" size="small" v-if="scope.row.status == 3 && !scope.row.comingSoon">
                                    <div>
                                        <span class="icon-liveStatus">
                                            <img src="../../../static/images/icon_waiting.png"/>
                                        </span>
                                        <span style="color: #000000;">{{ $t("new.title9") }}</span>
                                    </div>
                                </span>
                                <span type="text" size="small" v-if="scope.row.status == 3 && scope.row.comingSoon">
                                    <div>
                                        <span class="icon-liveStatus">
                                            <img src="../../../static/images/icon_waiting.png"/>
                                        </span>
                                        <span style="color: #000000;">{{$t("courseOnline.comingSoon")}}</span>
                                    </div>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('manage.coursesOnline')" min-width="60" show-overflow-tooltip align="center" class-name="nqt__pp" column-key="popup">
                            <template slot-scope="scope">
                                <div class="nqt__totl_std">
                                    <div @click="showPopupLive({courseLiveId: scope.row.courseLiveId, type: 0})">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" viewBox="0 0 172 172">
                                            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;">
                                                <path d="M0,172v-172h172v172z" fill="none"></path>
                                                <g fill="#e74c3c">
                                                    <path
                                                        d="M86,17.2112c-24.3208,0 -34.4,15.6004 -34.4,34.4c0,6.3296 3.02344,12.68724 3.02344,12.68724c-1.21547,0.69947 -3.21443,2.91979 -2.7099,6.86432c0.94027,7.35587 4.12925,9.22906 6.15885,9.38386c0.774,6.8628 8.14761,15.64152 10.72761,16.92005v11.46667c-5.73333,17.2 -51.6,5.73333 -51.6,45.86667h68.49766c-3.44573,-6.9144 -5.43099,-14.68307 -5.43099,-22.93333c0,-21.86693 13.62563,-40.5172 32.83229,-48.02786c0.3956,-1.12373 0.70825,-2.23152 0.82865,-3.29219c2.0296,-0.1548 5.21858,-2.02799 6.15885,-9.38386c0.50454,-3.95027 -1.49443,-6.16485 -2.70989,-6.86432c0,0 3.02344,-5.74418 3.02344,-12.68724c0,-13.92053 -5.46387,-25.8 -17.2,-25.8c0,0 -4.0764,-8.6 -17.2,-8.6zM131.86667,91.73333c-22.16507,0 -40.13333,17.96827 -40.13333,40.13333c0,22.16507 17.96827,40.13333 40.13333,40.13333c22.16507,0 40.13333,-17.96827 40.13333,-40.13333c0,-22.16507 -17.96827,-40.13333 -40.13333,-40.13333zM149.06667,114.66667c1.4663,0 2.93278,0.55882 4.05364,1.67969c2.24173,2.24173 2.24173,5.86556 0,8.10729l-22.93333,22.93333c-1.118,1.118 -2.58591,1.67969 -4.05364,1.67969c-1.46773,0 -2.93564,-0.56169 -4.05364,-1.67969l-11.46667,-11.46667c-2.24173,-2.24173 -2.24173,-5.86556 0,-8.10729c2.24173,-2.24173 5.86556,-2.24173 8.10729,0l7.41302,7.41302l18.87969,-18.87969c1.12087,-1.12087 2.58734,-1.67969 4.05364,-1.67969z"
                                                    ></path>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>{{scope.row.totalStudentJoin}}</span>
                                    </div>
                                    <div @click="showPopupLive({courseLiveId: scope.row.courseLiveId, type: 1})">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172">
                                            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;">
                                                <path d="M0,172v-172h172v172z" fill="none"></path>
                                                <g fill="#cccccc">
                                                    <path
                                                        d="M86,17.2112c-24.3208,0 -34.4,15.6004 -34.4,34.4c0,6.3296 3.02344,12.68724 3.02344,12.68724c-1.21547,0.69947 -3.21443,2.91979 -2.7099,6.86432c0.94027,7.35587 4.12925,9.22906 6.15885,9.38386c0.774,6.8628 8.14761,15.64152 10.72761,16.92005v11.46667c-5.73333,17.2 -51.6,5.73333 -51.6,45.86667h68.49766c-3.44573,-6.9144 -5.43099,-14.68307 -5.43099,-22.93333c0,-21.86693 13.62563,-40.5172 32.83229,-48.02786c0.3956,-1.12373 0.70825,-2.23152 0.82865,-3.29219c2.0296,-0.1548 5.21858,-2.02799 6.15885,-9.38386c0.50454,-3.95027 -1.49443,-6.16485 -2.70989,-6.86432c0,0 3.02344,-5.74418 3.02344,-12.68724c0,-13.92053 -5.46387,-25.8 -17.2,-25.8c0,0 -4.0764,-8.6 -17.2,-8.6zM131.86667,91.73333c-22.16507,0 -40.13333,17.96827 -40.13333,40.13333c0,22.16507 17.96827,40.13333 40.13333,40.13333c22.16507,0 40.13333,-17.96827 40.13333,-40.13333c0,-22.16507 -17.96827,-40.13333 -40.13333,-40.13333zM149.06667,114.66667c1.4663,0 2.93278,0.55882 4.05364,1.67969c2.24173,2.24173 2.24173,5.86556 0,8.10729l-22.93333,22.93333c-1.118,1.118 -2.58591,1.67969 -4.05364,1.67969c-1.46773,0 -2.93564,-0.56169 -4.05364,-1.67969l-11.46667,-11.46667c-2.24173,-2.24173 -2.24173,-5.86556 0,-8.10729c2.24173,-2.24173 5.86556,-2.24173 8.10729,0l7.41302,7.41302l18.87969,-18.87969c1.12087,-1.12087 2.58734,-1.67969 4.05364,-1.67969z"
                                                    ></path>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>{{scope.row.totalStudentNoJoin}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="userType != 2" :label="$t('manage.download')" min-width="60" show-overflow-tooltip align="center" class-name="nqt__pp" column-key="download">
                            <template slot-scope="scope">
                                <span class="nqt__download" @click="download(scope.row)" :class="[{actt__tt__g: scope.row.status == 1}, {actt__tt__r: scope.row.status == 2}, {actt__tt__b: scope.row.status == 2}]">
                                    &#10515;
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: center; margin-top: 10px;" v-if="data.length">
                        <el-pagination background @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" layout="prev, pager, next" :total="data.length"></el-pagination>
                    </div>
                </div>
            </div>
            <!-- mobile el_dialog_live_lesson -->
            <div class="course_box_mobile">
                <div class="box-1" v-for="(item, index) in gridData" :key="item.value">
                    <div @click="activeRow(index)" class="title_course_box" :class="{'turn-arrow': activeID == index}">
                        <div class="title_course">
                            <span type="text" size="small" v-if="item.status == 1">
                                <div style="color: #118e07;">
                                    <span class="icon-liveStatus">
                                        <img src="../../../static/images/icon_stop.png"/>
                                    </span>
                                    {{ item.courseName }}
                                </div>
                            </span>
                            <span type="text" size="small" v-if="item.status == 2">
                                <div style="color: #da251d;">
                                    <span class="icon-liveStatus">
                                        <img src="../../../static/images/icon_online.png"/>
                                    </span>
                                    {{ item.courseName }}
                                </div>
                            </span>
                            <span type="text" size="small" v-if="item.status == 3">
                                <div style="color: #000000;">
                                    <span class="icon-liveStatus">
                                        <img src="../../../static/images/icon_waiting.png"/>
                                    </span>
                                    {{ item.courseName }}
                                </div>
                            </span>
                        </div>
                    </div>
                    <div class="content_box" :class="{'active-content': activeID == index}">
                        <div class="content_new">
                            <h1>{{ $t("home.teachingTime") }}:</h1>
                            <span>{{ item.liveDate }}</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("studySituationList.validityPeriodStart") }}:</h1>
                            <span>{{ item.liveTimeStart }}</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("studySituationList.validityPeriodEnd") }}:</h1>
                            <span>{{ item.liveTimeEnd }}</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("home.status") }}:</h1>
                            <span type="text" size="small" v-if="item.status == 1">
                                <div>
                                    {{ $t("new.title7") }}
                                </div>
                            </span>
                            <span type="text" size="small" v-if="item.status == 2">
                                <div>
                                    {{ $t("new.title8") }}
                                </div>
                            </span>
                            <span type="text" size="small" v-if="item.status == 3 && !item.comingSoon">
                                <div>
                                    {{ $t("new.title9") }}
                                </div>
                            </span>
                            <span type="text" size="small" v-if="item.status == 3 && item.comingSoon">
                                <div>
                                    {{$t("courseOnline.comingSoon")}}
                                </div>
                            </span>
                        </div>
                        <div class="content_new btn_content_new_mb">
                            <h1>{{$t("manage.present")}}:</h1>
                            <div class="nqt__mb__total" @click="showPopupLive({courseLiveId: item.courseLiveId, type: 0})">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" viewBox="0 0 172 172">
                                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;">
                                        <path d="M0,172v-172h172v172z" fill="none"></path>
                                        <g fill="#e74c3c">
                                            <path
                                                d="M86,17.2112c-24.3208,0 -34.4,15.6004 -34.4,34.4c0,6.3296 3.02344,12.68724 3.02344,12.68724c-1.21547,0.69947 -3.21443,2.91979 -2.7099,6.86432c0.94027,7.35587 4.12925,9.22906 6.15885,9.38386c0.774,6.8628 8.14761,15.64152 10.72761,16.92005v11.46667c-5.73333,17.2 -51.6,5.73333 -51.6,45.86667h68.49766c-3.44573,-6.9144 -5.43099,-14.68307 -5.43099,-22.93333c0,-21.86693 13.62563,-40.5172 32.83229,-48.02786c0.3956,-1.12373 0.70825,-2.23152 0.82865,-3.29219c2.0296,-0.1548 5.21858,-2.02799 6.15885,-9.38386c0.50454,-3.95027 -1.49443,-6.16485 -2.70989,-6.86432c0,0 3.02344,-5.74418 3.02344,-12.68724c0,-13.92053 -5.46387,-25.8 -17.2,-25.8c0,0 -4.0764,-8.6 -17.2,-8.6zM131.86667,91.73333c-22.16507,0 -40.13333,17.96827 -40.13333,40.13333c0,22.16507 17.96827,40.13333 40.13333,40.13333c22.16507,0 40.13333,-17.96827 40.13333,-40.13333c0,-22.16507 -17.96827,-40.13333 -40.13333,-40.13333zM149.06667,114.66667c1.4663,0 2.93278,0.55882 4.05364,1.67969c2.24173,2.24173 2.24173,5.86556 0,8.10729l-22.93333,22.93333c-1.118,1.118 -2.58591,1.67969 -4.05364,1.67969c-1.46773,0 -2.93564,-0.56169 -4.05364,-1.67969l-11.46667,-11.46667c-2.24173,-2.24173 -2.24173,-5.86556 0,-8.10729c2.24173,-2.24173 5.86556,-2.24173 8.10729,0l7.41302,7.41302l18.87969,-18.87969c1.12087,-1.12087 2.58734,-1.67969 4.05364,-1.67969z"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                                <span>{{item.totalStudentJoin}}</span>
                            </div>
                        </div>
                        <div class="content_new btn_content_new_mb">
                            <h1>{{$t("manage.absent")}}:</h1>
                            <div class="nqt__mb__total" @click="showPopupLive({courseLiveId: item.courseLiveId, type: 1})">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" viewBox="0 0 172 172">
                                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;">
                                        <path d="M0,172v-172h172v172z" fill="none"></path>
                                        <path d="M0,172v-172h172v172z" fill="none"></path>
                                        <g fill="#cccccc">
                                            <path
                                                d="M86,17.2112c-24.3208,0 -34.4,15.6004 -34.4,34.4c0,6.3296 3.02344,12.68724 3.02344,12.68724c-1.21547,0.69947 -3.21443,2.91979 -2.7099,6.86432c0.94027,7.35587 4.12925,9.22906 6.15885,9.38386c0.774,6.8628 8.14761,15.64152 10.72761,16.92005v11.46667c-5.73333,17.2 -51.6,5.73333 -51.6,45.86667h68.49766c-3.44573,-6.9144 -5.43099,-14.68307 -5.43099,-22.93333c0,-21.86693 13.62563,-40.5172 32.83229,-48.02786c0.3956,-1.12373 0.70825,-2.23152 0.82865,-3.29219c2.0296,-0.1548 5.21858,-2.02799 6.15885,-9.38386c0.50454,-3.95027 -1.49443,-6.16485 -2.70989,-6.86432c0,0 3.02344,-5.74418 3.02344,-12.68724c0,-13.92053 -5.46387,-25.8 -17.2,-25.8c0,0 -4.0764,-8.6 -17.2,-8.6zM131.86667,91.73333c-22.16507,0 -40.13333,17.96827 -40.13333,40.13333c0,22.16507 17.96827,40.13333 40.13333,40.13333c22.16507,0 40.13333,-17.96827 40.13333,-40.13333c0,-22.16507 -17.96827,-40.13333 -40.13333,-40.13333zM149.06667,114.66667c1.4663,0 2.93278,0.55882 4.05364,1.67969c2.24173,2.24173 2.24173,5.86556 0,8.10729l-22.93333,22.93333c-1.118,1.118 -2.58591,1.67969 -4.05364,1.67969c-1.46773,0 -2.93564,-0.56169 -4.05364,-1.67969l-11.46667,-11.46667c-2.24173,-2.24173 -2.24173,-5.86556 0,-8.10729c2.24173,-2.24173 5.86556,-2.24173 8.10729,0l7.41302,7.41302l18.87969,-18.87969c1.12087,-1.12087 2.58734,-1.67969 4.05364,-1.67969z"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                                <span>{{item.totalStudentNoJoin}}</span>
                            </div>
                        </div>
                        <div class="btn-course" @click="joinLiveMb(item)">
                            <el-button type="text" size="small">
                                <span class="nqt__mb__btn">{{ $t("home.clickJump") }}</span>
                            </el-button>
                        </div>
                    </div>
                </div>

                <el-col :span="24" class="toolbar" style="text-align: center;" v-if="data.length">
                    <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" layout="prev, pager, next" :total="data.length" background></el-pagination>
                </el-col>
            </div>

            <!-- end mobile el_dialog_live_lesson -->
            <div v-if="!data.length && !loading" class="no-content">
                <img src="/static/images/noresult.jpg"/>
                <p>{{ $t("search.result") }}</p>
            </div>
        </div>

        <!-- Popup students -->
        <popup v-if="showModal" :data="popupData" @close="showModal = false" />

        <!-- Dialog thông báo tham gia trước -->
        <el-dialog :title='$lang() == 3 ? $t("online_ja.title") : $t("new.title86")' :visible.sync="dialogTableVisible" width="50%">
            <template v-if="$lang() != 3">
                <p class="wordBreak-all">{{$t("courseOnline.btitle1").replace(/XXX/g, $t("home.clickJump"))}}</p>
                <br />
                <p class="wordBreak-all">{{$t("courseOnline.btitle2").replace(/XXX/g, $t("courseOnline.draft"))}}</p>
                <p class="wordBreak-all">{{$t("courseOnline.btitle3")}}</p>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogTableVisible = false">{{ $t("js.cancel") }}</el-button>
                    <el-button type="primary" @click="draft()">{{ $t("courseOnline.draft") }}</el-button>
                    <el-button type="primary" class="xam_duP" @click="attendance">{{ $t("home.clickJump") }}</el-button>
                </span>
            </template>
            <template v-else>
                <p class="wordBreak-all">{{$t("online_ja.title1").replace(/XXX/g, $t("online_ja.clickJump"))}}</p>
                <br />
                <p class="wordBreak-all" style="color: red !important">{{$t("online_ja.title2").replace(/XXX/g, $t("online_ja.draft"))}}</p>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogTableVisible = false">{{ $t("online_ja.cancel") }}</el-button>
                    <el-button type="primary" @click="draft()">{{ $t("online_ja.draft") }}</el-button>
                    <el-button type="primary" class="xam_duP" @click="attendance">{{ $t("online_ja.clickJump") }}</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- Dialog thông báo tham gia đối với khóa học sắp bắt đầu -->
        <el-dialog :title='$t("new.title86")' :visible.sync="dialogTableVisibleCommingSoon" width="50%">
            <p class="wordBreak-all" v-if="course != null">{{$t("courseOnline.title1").replace(/XXXXX/g, course.courseName)}}</p>
            <p class="wordBreak-all">{{$t("courseOnline.title2").replace(/XX/g, hour + " " + this.$t("manage_student.hour") + " " + minutes)}}</p>
            <br />
            <p class="wordBreak-all">{{$t("courseOnline.btitle1").replace(/XXX/g, $t("home.clickJump"))}}</p>
            <p class="wordBreak-all">{{$t("courseOnline.btitle2").replace(/XXX/g, $t("courseOnline.draft"))}}</p>
            <p class="wordBreak-all">{{$t("courseOnline.btitle3")}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisibleCommingSoon = false">{{ $t("js.cancel") }}</el-button>
                <el-button type="primary" @click="draft()">{{ $t("courseOnline.draft") }}</el-button>
                <el-button type="primary" class="xam_duP" @click="attendance()">{{ $t("home.clickJump") }}</el-button>
            </span>
        </el-dialog>

        <!-- Dialog thông báo tham gia đối với khóa học đã kết thúc -->
        <el-dialog :title='$lang() == 3 ? $t("online_ja.title") : $t("new.title86")' :visible.sync="dialogTableVisibleEnd" width="50%">
            <template v-if="$lang() != 3">
                <p class="wordBreak-all">{{$t("courseOnline.attendance").replace(/XXX/g, $t("courseOnline.join"))}}</p>
                <br />
                <p class="wordBreak-all">{{$t("courseOnline.comfirmRejoin")}}</p>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogTableVisibleEnd = false">{{ $t("js.cancel") }}</el-button>
                    <el-button type="primary" @click="draft()">{{ $t("courseOnline.reBegin") }}</el-button>
                    <el-button type="primary" class="xam_duP" @click="attendanceCf()">{{ $t("courseOnline.join") }}</el-button>
                </span>
            </template>
            <template v-else>
                <p class="wordBreak-all">{{$t("online_ja.attendance1")}}</p>
                <p class="wordBreak-all">{{$t("online_ja.attendance2").replace(/XXX/g, $t("online_ja.join"))}}</p>
                <p class="wordBreak-all">{{$t("online_ja.attendance3").replace(/XXX/g, $t("online_ja.rejoin"))}}</p>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogTableVisibleEnd = false">{{ $t("online_ja.cancel") }}</el-button>
                    <el-button type="primary" @click="draft()">{{ $t("online_ja.rejoin") }}</el-button>
                    <el-button type="primary" class="xam_duP" @click="attendanceCf()">{{ $t("online_ja.join") }}</el-button>
                </span>
            </template>
        </el-dialog>

        <loading class="loading--lesson" :showLoading="loading" />

    </div>
</template>

<script>
    import popup from "@/components/popup/studentsLive";
    import loading from "@/components/loading/loading";
    import { mapState } from "vuex";

    export default {
        data() {
            return {
                hour: 0,
                minutes: 0,
                optionStatus: [
                    { value: 0, label: this.$t("new.title6") },
                    { value: 1, label: this.$t("new.title7") },
                    { value: 2, label: this.$t("new.title8") },
                    { value: 3, label: this.$t("new.title9") },
                ],
                userType: 0,
                userId: null,
                activeID: null,
                data: [],
                disableForm: false,
                pageSize: 20,
                page: 1,
                course: null,
                form: {
                    courseName: null,
                    status: 0,
                    from: null,
                    to: null
                },
                asc: true,
                property: 'courseName',
                popupData: {
                    type: 0,
                    courseLiveId: null
                },
                showModal: false,
                dialogTableVisible: false,
                dialogTableVisibleCommingSoon: false,
                dialogTableVisibleEnd: false,
                loading: false,
                first: true
            };
        },
        components: {
            popup,
            loading
        },
        computed: {
            // Render table
            gridData() {
                this.pageSize = this.mobile ? 5 : 15;
                let data = this.data.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
                return this.sortedTables(data, this.asc);
            },

            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        created() {
            this.$autoLogin().then(
                () => {
                    this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
                    this.userType = window.sessionStorage.getItem("userType");
                    this.disableForm = !this.mobile ? false : true;
                    this.reset();
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        methods: {
            // Sort table
            tableHeaderStyle({ columnIndex }) {
                if (columnIndex != 5 && columnIndex != 6) return "cursor: pointer";
            },

            sortTable(column) {
                if (column.property != undefined && column.property != null) {
                    this.property = column.property;
                    this.asc = !this.asc;
                    this.first = false;
                }
            },

            sortDefault: function (ar) {
                return ar.sort((a, b) =>
                    a.liveDate == b.liveDate ? a.liveTimeStart.localeCompare(b.liveTimeStart) : a.liveDate.localeCompare(b.liveDate)
                    // a.liveDate == b.liveDate ? (a.liveTimeStart == b.liveTimeStart ? a.coursename.localeCompare(b.coursename) : a.liveTimeStart.localeCompare(b.liveTimeStart)) : a.liveDate.localeCompare(b.liveDate)
                );
            },

            sortedTables(data, type) {
                if (this.first) {
                    return this.sortDefault(data);
                } else {
                    return type ? data.sort((a, b) => a[this.property].localeCompare(b[this.property])) : data.sort((a, b) => b[this.property].localeCompare(a[this.property]));
                }
            },

            icons(h, { column }) {
                return [
                    h("span", column.label),
                    h("i", {
                        class: "el-icon-d-caret",
                        style: "color:#ffffff;margin-left:3px;",
                    }),
                ];
            },
            // End sort table

            // Download tất cả danh sách khóa học online
            downloadAll: function () {
                const self = this;
                self.loading = true;

                Promise.all(
                    this.data.map((item) => {
                        return self.convertData(item);
                    })
                ).then(function (results) {

                    const result = [].concat(...results);

                    // Khai báo header CSV
                    var headerName = [
                        {
                            key: "courseName",
                            value: "home.courseName",
                        },
                        {
                            key: "liveDate",
                            value: "home.teachingTime",
                        },
                        {
                            key: "liveTimeStart",
                            value: "studySituationList.validityPeriodStart",
                        },
                        {
                            key: "liveTimeEnd",
                            value: "studySituationList.validityPeriodEnd",
                        },
                        {
                            key: "textStatus",
                            value: "home.status",
                        },
                        {
                            key: "studentName",
                            value: "profile.name",
                        },
                        {
                            key: "email",
                            value: "profile.email",
                        },
                        {
                            key: "liveTeacher",
                            value: "manage_student.teacher",
                        },
                        {
                            key: "studyTime",
                            value: "profile.studyTime",
                        },
                        {
                            key: "liveLink",
                            value: "profile.link",
                        },
                        {
                            key: "status",
                            value: "manage.statusAttendance",
                        },
                    ];
                    var params = {
                        header: true,
                        titles: ["studentName", "status", "studyTime", "email", "courseName", "liveDate", "liveTimeStart", "liveTimeEnd", "liveTeacher", "liveLink", "textStatus"],
                        data: result,
                        headerName: headerName,
                    };

                    if (result.length > 0) {
                        // Download
                        self.exportCsv(params);
                    } else {
                        self.$alert(window.vm.$i18n.t("new.title184"), "", {
                            confirmButtonText: window.vm.$i18n.t("js.confirm"),
                            callback: () => {}
                        });
                    }

                    self.loading = false;
                })
            },

            // Format data truớc khi xuất
            convertData: async function (item) {
                // Trạng thái
                var status = "";
                if (item.status == 2) {
                    status = this.$t("new.title8");
                } else if (item.status == 3) {
                    status = this.$t("new.title9");
                } else {
                    status = this.$t("new.title7");
                }
                item["textStatus"] = status;

                // Lấy danh sách học viên đã tham gia
                let studentJoin = await this.getLiveCourseParticipantList(item.courseLiveId);

                // Lấy danh sách học viên chưa tham gia
                let studentNoJoin = await this.getLiveCourseNonParticipantList(item.courseLiveId);

                let csv = studentJoin.concat(studentNoJoin);

                // Định dạng csv
                const results = csv.reduce((a, v) => {
                    v.textStatus = item.textStatus;
                    v.courseName = item.courseName;
                    v.liveDate = item.liveDate;
                    v.liveLink = item.liveLink;
                    v.liveTeacher = item.liveTeacher.replace(/,/g, ' |');
                    v.liveTimeEnd = item.liveTimeEnd;
                    v.liveTimeStart = item.liveTimeStart;
                    a.push(v);
                    return a;
                }, []);

                return results;
            },

            // Download danh sách học viên tham gia khóa online
            download: async function (item) {

                this.loading = true;

                // Trạng thái
                var status = "";
                if (item.status == 2) {
                    status = this.$t("new.title8");
                } else if (item.status == 3) {
                    status = this.$t("new.title9");
                } else {
                    status = this.$t("new.title7");
                }
                item["textStatus"] = status;

                // Lấy danh sách học viên đã tham gia
                let studentJoin = await this.getLiveCourseParticipantList(item.courseLiveId);

                // Lấy danh sách học viên chưa tham gia
                let studentNoJoin = await this.getLiveCourseNonParticipantList(item.courseLiveId);

                let csv = studentJoin.concat(studentNoJoin);

                // Định dạng csv
                const results = csv.reduce((a, v) => {
                    v.textStatus = item.textStatus;
                    v.courseName = item.courseName;
                    v.liveDate = item.liveDate;
                    v.liveLink = item.liveLink;
                    v.liveTeacher = item.liveTeacher.replace(/,/g, ' |');
                    v.liveTimeEnd = item.liveTimeEnd;
                    v.liveTimeStart = item.liveTimeStart;
                    a.push(v);
                    return a;
                }, []);

                // Khai báo header CSV
                var headerName = [
                    {
                        key: "courseName",
                        value: "home.courseName",
                    },
                    {
                        key: "liveDate",
                        value: "home.teachingTime",
                    },
                    {
                        key: "liveTimeStart",
                        value: "studySituationList.validityPeriodStart",
                    },
                    {
                        key: "liveTimeEnd",
                        value: "studySituationList.validityPeriodEnd",
                    },
                    {
                        key: "textStatus",
                        value: "home.status",
                    },
                    {
                        key: "studentName",
                        value: "profile.name",
                    },
                    {
                        key: "email",
                        value: "profile.email",
                    },
                    {
                        key: "liveTeacher",
                        value: "manage_student.teacher",
                    },
                    {
                        key: "studyTime",
                        value: "profile.studyTime",
                    },
                    {
                        key: "liveLink",
                        value: "profile.link",
                    },
                    {
                        key: "status",
                        value: "manage.statusAttendance",
                    },
                ];
                var params = {
                    header: true,
                    titles: ["studentName", "status", "studyTime", "email", "courseName", "liveDate", "liveTimeStart", "liveTimeEnd", "liveTeacher", "liveLink", "textStatus"],
                    data: results,
                    headerName: headerName,
                };

                // Kiểm tra dữ liệu trước khi export
                if (results.length > 0) {
                    // Download
                    this.exportCsv(params);
                } else {
                    this.$alert(window.vm.$i18n.t("new.title184"), "", {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        callback: () => {}
                    });
                }

                this.loading = false;
            },

            // Lấy danh sách học viên đã tham gia
            getLiveCourseParticipantList: function (courseLiveId) {
                const self = this;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getLiveCourseParticipantList", {
                            courseId: courseLiveId,
                        })
                        .then((response) => {
                            let listStudents = [];
                            response.data.forEach(el => {
                                if (el.userType == '2') {
                                    listStudents.push(el)
                                }
                            })
                            let data = listStudents.reduce((acc, curr) => {
                                let item = {};
                                item.studentName = curr.studentName;
                                item.email = curr.email;
                                item.studyTime = curr.studyTime || "ー";
                                item.status = self.$t("manage.present");
                                acc.push(item);
                                return acc;
                            }, []);
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy danh sách học viên chưa tham gia
            getLiveCourseNonParticipantList: function (courseLiveId) {
                const self = this;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getLiveCourseNonParticipantList", {
                            courseId: courseLiveId,
                        })
                        .then((response) => {
                            let listStudents = [];
                            response.data.forEach(el => {
                                if (el.userType == '2') {
                                    listStudents.push(el)
                                }
                            })
                            let data = listStudents.reduce((acc, curr) => {
                                let item = {};
                                item.studentName = curr.studentName;
                                item.email = curr.email;
                                item.studyTime = curr.studyTime || "ー";
                                item.status = self.$t("manage.absent");
                                acc.push(item);
                                return acc;
                            }, []);
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Format time
            appendLeadingZeroes: function (n) {
                if (n <= 9) {
                    return "0" + n;
                }
                return n;
            },

            // Reset data
            reset: function () {

                // Lấy ngày hiện tại
                let currentDate = new Date();
                let today = currentDate.getFullYear() + "-" + this.appendLeadingZeroes(currentDate.getMonth() + 1) + "-" + this.appendLeadingZeroes(currentDate.getDate());

                // Reset data
                this.form.from = today;
                this.form.to = today;
                this.form.status = 0;
                this.form.courseName = null;

                // Research
                this.search(this.form);
            },

            // Toogle item in mobile
            activeRow: function (activeID) {
                if (this.activeID == activeID && this.activeID != null) {
                    this.activeID = null;
                } else {
                    this.activeID = activeID;
                }
            },

            // Tìm kiếm tất cả khóa học theo điều kiện
            search: async function (param) {
                this.page = 1;
                this.activeID = null;
                this.first = true;
                this.loading = true;
                this.data = await this.getAllCousrseOnline(param);
                this.loading = false;
            },

            // Lấy số trang hiện tại
            handleCurrentChange(val) {
                this.page = val;
                this.activeID = null;
            },

            // Hiển thị poup
            showPopupLive(data) {
                this.popupData = data;
                this.showModal = true;
            },

            // Xử lý tham gia ở màn PC
            joinLive: async function (val, row) {

                if (row.columnKey == "popup" || row.columnKey == "download") return;

                this.course = val;

                // Khóa học đã kêt thúc
                if (val.status == 1) {
                    this.dialogTableVisibleEnd = true;
                    return
                }

                // Khóa học đang diễn ra
                if (val.status == 2) {
                    this.dialogTableVisible = true;
                    return
                }

                // Khóa học chưa diễn ra và sắp diễn ra
                if (val.status == 3) {

                    let liveDate = new Date(val.liveDate);
                    let today = new Date();

                    // Kiểm tra ngày bắt đầu.
                    if (!this.dateCompare(liveDate, '===', today)) {

                        // Ngày tương lai
                        this.$alert(this.$t("manage.lesson_begin"), "", {
                            confirmButtonText: this.$t("js.confirm"),
                            type:"warning",
                            dangerouslyUseHTMLString:true
                        });
                    } else {
                        let minutesToday = this.getSumMinutes(today);
                        let minutesLiveTime = this.getSumMinutesByStr(val.liveTimeStart);
                        let minutes = minutesLiveTime - minutesToday;

                        this.hour = Math.floor(minutes/60);
                        this.minutes = minutes - (this.hour * 60);

                        // Kiểm tra thời gian bắt đầu.
                        if (!val.comingSoon) {
                            this.dialogTableVisibleCommingSoon = true;
                            return;
                        }
                        if (val.comingSoon) {
                            this.dialogTableVisible = true;
                            return;
                        }
                    }
                }
            },

            // Xử lý tham gia ở màn mobile
            joinLiveMb: async function (val) {
                this.course = val;

                // Khóa học đã kêt thúc
                if (val.status == 1) {
                    this.dialogTableVisibleEnd = true;
                    return
                }

                // Khóa học đang diễn ra
                if (val.status == 2) {
                    this.dialogTableVisible = true;
                    return
                }

                // Khóa học chưa diễn ra và sắp diễn ra
                if (val.status == 3) {

                    let liveDate = new Date(val.liveDate);
                    let today = new Date();

                    // Kiểm tra ngày bắt đầu.
                    if (!this.dateCompare(liveDate, '===', today)) {

                        // Ngày tương lai
                        this.$alert(this.$t("manage.lesson_begin"), "", {
                            confirmButtonText: this.$t("js.confirm"),
                            type:"warning",
                            dangerouslyUseHTMLString:true
                        });
                    } else {
                        let minutesToday = this.getSumMinutes(today);
                        let minutesLiveTime = this.getSumMinutesByStr(val.liveTimeStart);
                        let minutes = minutesLiveTime - minutesToday;

                        this.hour = Math.floor(minutes/60);
                        this.minutes = minutes - (this.hour * 60);

                        // Kiểm tra thời gian bắt đầu.
                        if (!val.comingSoon) {
                            this.dialogTableVisibleCommingSoon = true;
                            return;
                        }
                        if (val.comingSoon) {
                            this.dialogTableVisible = true;
                            return;
                        }
                    }
                }
            },

            attendanceCf: async function () {
                if (this.course.quantity != null && this.course.totalStudentJoin >= this.course.quantity) {
                    this.$alert(this.$t("courseOnline.quantityAlert"), "", {
                        confirmButtonText: this.$t("js.confirm"),
                        type:"warning",
                        dangerouslyUseHTMLString:true
                    });

                    // Đóng dialog thông báo
                    this.dialogTableVisible = false;
                    this.dialogTableVisibleCommingSoon = false;
                    this.dialogTableVisibleEnd = false;
                    return;
                }
                
                // Điểm danh
                let status =  await this.saveLiveCourseAttendanceStatus(this.course);
                if (status == 1) {
                    // Thông báo thành công
                    this.$message({
                        type: 'success',
                        message: this.$t("courseOnline.joinSuccess")
                    });
                }

                // Lấy lại danh sách
                this.search(this.form);

                // Đóng dialog thông báo
                this.dialogTableVisible = false;
                this.dialogTableVisibleCommingSoon = false;
                this.dialogTableVisibleEnd = false;
            },

            // Tham gia có điểm danh
            attendance: async function () {

                if (this.course.quantity != null && this.course.totalStudentJoin >= this.course.quantity) {
                    this.$alert(this.$t("courseOnline.quantityAlert"), "", {
                        confirmButtonText: this.$t("js.confirm"),
                        type:"warning",
                        dangerouslyUseHTMLString:true
                    });

                    // Đóng dialog thông báo
                    this.dialogTableVisible = false;
                    this.dialogTableVisibleCommingSoon = false;
                    this.dialogTableVisibleEnd = false;
                    return;
                }

                // Lấy kích thước màn hình
                let widthScreen = screen.width;
                let heightScreen = screen.height;

                // Check link
                let link = this.course.liveLink;
                if (!this.checkValidUrl(this.course.liveLink)) {
                    link = "https://" + this.course.liveLink;
                }

                // Redirect tới ggmeet
                window.open(link, "_blank", `toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=${widthScreen},height=${heightScreen}`);

                // Điểm danh
                let status =  await this.saveLiveCourseAttendanceStatus(this.course);
                if (status == 1) {
                    // Thông báo thành công
                    this.$message({
                        type: 'success',
                        message: this.$t("courseOnline.joinSuccess")
                    });
                }

                // Lấy lại danh sách
                this.search(this.form);

                // Đóng dialog thông báo
                this.dialogTableVisible = false;
                this.dialogTableVisibleCommingSoon = false;
                this.dialogTableVisibleEnd = false;

            },

            // Tham gia không có điểm danh
            draft: function () {

                // Check link
                let link = this.course.liveLink;
                if (!this.checkValidUrl(this.course.liveLink)) {
                    link = "https://" + this.course.liveLink;
                }

                // Redirect tới ggmeet
                window.open(link, "_blank");

                // Đóng dialog thông báo
                this.dialogTableVisible = false;
                this.dialogTableVisibleCommingSoon = false;
                this.dialogTableVisibleEnd = false;
            },

            // Lấy toàn bộ khóa học online theo param
            getAllCousrseOnline: function (param) {
                return new Promise((resolve) => {
                    this.companyId = window.sessionStorage.getItem("companyId");
                    this.$api
                        .post("/home/getLiveLesson", {
                            languageType: this.$lang(),
                            courseName: param.courseName,
                            from: param.from,
                            to: param.to,
                            status: param.status,
                        })
                        .then((response) => {
                            let result = response.data.list;
                            let data = result.reduce((acc, curr) => {
                                let liveDate = new Date(curr.liveDate);
                                let today = new Date();
                                if (this.dateCompare(liveDate, '===', today)) {
                                    let minutesToday = this.getSumMinutes(today);
                                    let minutesLiveTime = this.getSumMinutesByStr(curr.liveTimeStart);
                                    let min = minutesLiveTime - minutesToday;
                                    if (min > 0 && min <= 15) {
                                        curr["comingSoon"] = true;
                                    } else {
                                        curr["comingSoon"] = false;
                                    }
                                } else {
                                    curr["comingSoon"] = false;
                                }
                                curr.status = parseInt(curr.status);
                                acc.push(curr);
                                return acc;
                            }, []);

                            resolve(data);
                        });
                });
            },

            // Điểm danh
            saveLiveCourseAttendanceStatus: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/saveLiveCourseAttendanceStatus", {
                            courseId: data.courseLiveId,
                            studentId: data.studentId
                        })
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
        },
    };
</script>
<style scoped>
    .wordBreak-all {
        word-break: break-word;
    }
    .actv,
    .actt__tt {
        cursor: pointer;
    }
    .actt__tt__g {
        color: #118e07 !important;
    }
    .actt__tt__r {
        color: #da251d !important;
    }
    .actt__tt__b {
        color: #000000 !important;
    }
    .nqttl__btn {
        border: 1px solid #d2d2d2;
        border-radius: 100rem;

        color: inherit;
        background: transparent;
        font-family: inherit;

        transition: linear 0.5s;
    }
    .nqt__pp:hover .actv {
        background: var(--focus);
        border-color: var(--focus);
        transform: translateY(-0.1rem);
    }

    .btn-hiden-display-mobile {
        margin-top: 15px;
        margin-bottom: 10px;
    }
    .el-row-box {
        margin-top: 25px;
    }
    .btn-hiden-display-mobile .btn-hiden {
        padding-right: 15px;
        padding-left: 15px;
        background: #888;
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        border-radius: 10px;
        border: 0;
        height: 36px;
    }
    .btn-hiden-display-mobile .btn-display {
        padding-right: 15px;
        padding-left: 15px;
        background: #0071c5;
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        border-radius: 10px;
        border: 0;
        height: 36px;
    }
    @media (max-width: 1112px) {
        .primarylists.list-mobile .titles.title_mobile {
            padding-left: 10px;
            left: 0 !important;
        }
    }
    .modal__btn {
        margin-top: 1rem;
        margin-left: 1rem;
        padding: 0.5rem 1.6rem;
        border: 1px solid #d2d2d2;
        border-radius: 1rem;

        color: inherit;
        background: transparent;
        font-size: 14px;
        font-family: inherit;
        letter-spacing: 0.2rem;

        transition: 0.2s;
        cursor: pointer;
    }

    .modal__btn:nth-of-type(1) {
        margin-right: 1rem;
    }

    .modal__btn:hover,
    .modal__btn:focus {
        background: var(--focus);
        border-color: var(--focus);
        transform: translateY(-0.2rem);
    }
    .nqt__download {
        font-size: 20px;
        font-weight: bolder;
    }
    .exam_btn.btn-login {
        width: 131px !important;
        float: right;
        margin-left: 5px !important;
    }
    .exam_btn.btn-login.disable {
        background: #d2d2d2 !important;
        cursor: no-drop;
    }
    .btn__pc_left {
        float: left !important;
    }
    .btn__pc {
        margin-bottom: 20px;
        margin-left: 5px !important;
    }
    .btn__mb {
        margin-bottom: 10px;
    }
    .btn_content_new_mb .modal__btn {
        margin: 0;
    }
    .nqt__pl5 {
        padding-left: 5px;
    }
    .nqt__pr5 {
        padding-right: 5px;
    }
    .select-new {
        border: 1px solid #dcdfe6;
    }
    .nqt__mb__btn {
        color: #fff;
    }
    .tt_nqt_tl {
        line-height: 41px;
        font-size: 14px;
        background-color: #f5f7fa;
        color: #909399;
        border: 1px solid #dcdfe6;
        padding: 0 13px !important;
    }
    .not_mbhhh {
        padding-left: 5px;
    }
    .not_osn {
        padding: 6px 10px !important;
        font-size: 20px;
        font-weight: 700;
        color: #424140;
    }
    .mq_js,
    .not_mb_jmb_5 {
        margin-top: 10px;
    }
    .not_mb_jmb_5 {
        border-radius: 5px;
    }
    .op_mb {
        line-height: 40px;
    }
    .nqt782k {
        position: relative;
    }
    .nqt782k span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .status__mb {
        border-right: none;
    }
    .nqt__totl_std {
      display: flex;
    }
    .nqt__totl_std > div {
      position: relative;
      flex: 50%;
      padding-left: 10px;
      transition: ease 0.5s;
    }
    .nqt__totl_std > div svg {
      fill: #000000;
      position: absolute;
      top: 0;
      left: 5px;
    }
    .nqt__totl_std > div span {
      margin-left: 15px;
    }
    .nqt__totl_std > div:hover {
        background-color: #bdc3c7;
        border-radius: 5px;
    }
    .nqt__mb__total {
        position: relative;
        width: auto;
        padding: 0.5rem 2.2rem;
        border: 1px solid #efefef;
        border-radius: 5px;
    }
    .nqt__mb__total svg{
        fill: #000000;
        position: absolute;
        top: 2px;
        left: 0.5rem;
    }
</style>



// WEBPACK FOOTER //
// src/views/live/course.vue